import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { FormGroup, Button, Intent, TextArea } from "@blueprintjs/core";
import { observable } from 'mobx';
import Toast from 'helpers/toaster';
import FormDrawer from 'components/FormDrawer';
import { FormSection, FieldError, MoreOptions } from 'components/FormBits';

const isBlank = (value) => value === undefined || value === null || String(value).trim() === '';

// Bring a field with an error into view and put the cursor in it.
const focusField = (id) => {
  setTimeout(() => {
    const field = document.getElementById(id);
    if (!field) return;
    field.scrollIntoView({ block: 'center', behavior: 'smooth' });
    field.focus({ preventScroll: true });
  }, 0);
};

@inject('serviceTypeCategoryStore') @observer
class ServiceTypeCategory extends Component {
  @observable error = null;

  componentDidUpdate(prevProps) {
    if (this.props.isOpen && !prevProps.isOpen) {
      this.error = null;
    }
  }

  // The name is required: say so under the field and put the cursor there.
  validate(object) {
    if (isBlank(object.name)) {
      this.error = 'Enter a name, e.g. Heating.';
      focusField('service-type-category-name');
      return false;
    }
    this.error = null;
    return true;
  }

  handleCloseDailog() {
    // clearing object
    this.props.serviceTypeCategoryStore.serviceTypeCategory.object = {}
    this.props.onClose()
  }

  createCategory() {
    let { 
      serviceTypeCategoryStore,
      serviceTypeCategoryStore:{
        serviceTypeCategory: {
          object
        }
      }
     } = this.props;

    if (!this.validate(object)) {
      return;
    }
    serviceTypeCategoryStore.create()
      .then(this.onSuccessfullyCreateCategory.bind(this))
      .catch(this.onFailCreateCategory.bind(this))
  }

  onSuccessfullyCreateCategory(response) {
    this.props.serviceTypeCategoryStore.serviceTypeCategory.object = {} // so the next Add starts blank
    this.props.serviceTypeCategoryStore.loadServiceTypeCategories();
    this.props.onSuccess()
    Toast.show({ message: "Service type category created successfully.", intent: Intent.SUCCESS })
  }

  onFailCreateCategory(error) {
    if(error.response && error.response.data && error.response.data.errors) {
      Toast.show({ message: error.response.data.errors, intent: Intent.DANGER })
    } else {
      Toast.show({ message: "Something went wrong. Failed to create/update service type category.", intent: Intent.DANGER })
    }
  }

  updateCategory() {
    let { 
      serviceTypeCategoryStore,
      serviceTypeCategoryStore:{
        serviceTypeCategory: {
          object
        }
      }
     } = this.props;
     
    if (!this.validate(object)) {
      return;
    }
    serviceTypeCategoryStore.update()
      .then(this.onSuccessfullyUpdateCategory.bind(this))
      .catch(this.onFailCreateCategory.bind(this))
  }

  onSuccessfullyUpdateCategory(response) {
    this.props.serviceTypeCategoryStore.serviceTypeCategory.object = {} // so the next Add starts blank
    this.props.onSuccess()
    Toast.show({ message: "Service type category updated successfully.", intent: Intent.SUCCESS })
  }

  render() {
    let {
      edit,
      serviceTypeCategoryStore: {
        serviceTypeCategory: {
          isLoading,
          object
        }
      }
    } = this.props;
    const busy = !!isLoading;
    const close = this.handleCloseDailog.bind(this);

    return(
      <FormDrawer
        title={edit ? "Edit service type category" : "New service type category"}
        icon={edit ? "edit" : "tag"}
        isOpen={this.props.isOpen}
        onClose={close}
        busy={busy}
        footer={
          <>
            <Button text="Cancel" onClick={close} disabled={busy} />
            {edit ?
              <Button
                intent={Intent.PRIMARY}
                icon="floppy-disk"
                text="Save changes"
                loading={busy}
                onClick={this.updateCategory.bind(this)}
              />
              :
              <Button
                intent={Intent.PRIMARY}
                icon="add"
                text="Create service type category"
                loading={busy}
                onClick={this.createCategory.bind(this)}
              />
            }
          </>
        }
      >
        <FormSection title="Category" hint="Groups service types, e.g. on the booking form.">
          <FormGroup
            className={this.error ? 'has-error' : undefined}
            label="Name"
            labelFor="service-type-category-name"
            labelInfo="*"
          >
            <input
              id="service-type-category-name"
              type='text'
              className='bp3-input bp3-fill'
              placeholder='e.g. Heating'
              defaultValue={object.name}
              aria-invalid={!!this.error}
              onChange={(event) => { object.name = event.target.value; this.error = null; } }
            />
            <FieldError>{this.error}</FieldError>
          </FormGroup>
          <MoreOptions label="Add a description" open={!isBlank(object.description)}>
            <FormGroup label="Description" labelFor="service-type-category-description">
              <TextArea
                id="service-type-category-description"
                fill={true}
                placeholder="e.g. Furnace and boiler repairs and tune-ups"
                defaultValue={object.description}
                onChange={(event) => { object.description = event.target.value } }
              />
            </FormGroup>
          </MoreOptions>
        </FormSection>
      </FormDrawer>
    )
  }

}

export default ServiceTypeCategory;